module.exports = __webpack_public_path__ + "img/Diego_Simas.8de83e3c.webp";